export default __webpack_public_path__ + "static/media/hht2_ep6_speaking_02.fe4d4262.png";